// extracted by mini-css-extract-plugin
export default {"FlipFlop":"index_FlipFlop__3zalX","right":"index_right__17Z9z","left":"index_left__Jz8DU","image":"index_image__33J-8","appear":"index_appear__2C6Bh"};